import { render, staticRenderFns } from "./SlideFadeTransition.vue?vue&type=template&id=49978c20&scoped=true"
import script from "./SlideFadeTransition.vue?vue&type=script&lang=js"
export * from "./SlideFadeTransition.vue?vue&type=script&lang=js"
import style0 from "./SlideFadeTransition.vue?vue&type=style&index=0&id=49978c20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49978c20",
  null
  
)

export default component.exports